import './CertificatesFAQ.scss';
import { AboutCertificates } from './AboutCertificates/AboutCertificates';
import { FAQ } from './FAQ/FAQ';

export const CertificatesFAQ = () => {
  return (
    <div className='certificates-faq-wrapper'>
      <AboutCertificates />
      <FAQ />
    </div>
  );
};
